import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import { Observable, from } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';
import { FirebaseAuthService } from './firebase-auth.service';
export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable({
	providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
	  constructor(private firebaseAuthService: FirebaseAuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has(InterceptorSkipHeader)) {
      const headers = request.headers.delete(InterceptorSkipHeader);
      return next.handle(request.clone({ headers }));
    }

    return this.firebaseAuthService.isAuthenticated().pipe(
      take(1),
      mergeMap(isAuthenticate => {
        if (isAuthenticate) {
          return this.firebaseAuthService.getJwt().pipe(
            mergeMap(jwt => {
              return this.setJwtOrSkip(request, next, jwt);
            })
          );
        }
        return next.handle(request);
      })
    );
  }

  private setJwtOrSkip(request: HttpRequest<any>, next: HttpHandler, jwt: string): Observable<HttpEvent<any>> {
    // ⚠️ Aqui está o ajuste essencial:
    if (request.body instanceof FormData) {
      // Só adiciona o Authorization, NÃO o Content-Type!
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${jwt}`
        }
      });
    } else {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${jwt}`,
          'Content-Type': 'application/json'
        }
      });
    }

    return next.handle(request);
  }
}
